module.exports = __webpack_public_path__ + "img/help.df38bbeb.svg";